/**
 * initialize youtube player for .b-video selectors
 */
import jQuery from 'jquery'

class Video {
  constructor(element) {
    if (!element) {
      return false
    }

    this.$element = jQuery(element)
    this.videoId = this.$element.data('video-id')
    this.player = null
    this.playerId = this.$element.find('.player').attr('id')

    document.addEventListener('on-youtube-iframe-api-ready', () => {
      this._iniYouTubePlayer()
    })

    this._onClickVideo()

    document.addEventListener('pause-all-videos', () => {
      if (this.player) {
        this.player.pauseVideo()
      }
    })
  }

  _iniYouTubePlayer() {
    const YT = window.YT

    if (!this.playerId || !this.videoId) {
      return false
    }

    this.player = new YT.Player(this.playerId, {
      videoId: this.videoId,
      playerVars: {
        playsinline: 1,
        rel: 0,
      },
    })
  }

  _onClickVideo() {
    this.$element.on('click', (e) => {
      e.preventDefault()

      const targetElement = jQuery(e.currentTarget)
      targetElement.addClass('is-active')
      this.player.playVideo()
    })
  }
}
export default Video
